<template>
	<v-col class="purchase-report">
		<ModalSearch ref="modalSearch" :isReset="isResetSearch" @action="cari"></ModalSearch>
		<ModalDetail ref="modalDetail" :detailTransactionProduct="detailTransactionProduct"></ModalDetail>
		<ModalConfirm ref="modalConfirm" :msg="msgConfirm" :status="confirmStatus" @action="processApprove"></ModalConfirm>
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Approval Transaksi</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-storefront</v-icon>
			<div class="pl-2">Stockist Area</div>
			<div class="px-2">/</div>
			<div>Approval Transaksi</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12" class="py-0 py-sm-3">
					<div class="d-flex justify-end">
						<v-btn depressed color="primary" class="white--text rounded-lg text-capitalize" @click="showSearch">
							<div class="d-flex">
								<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
								<div class="d-none d-sm-block">Cari</div>
							</div>
						</v-btn>
						<v-btn depressed color="grey lighten-1" class="ml-3 white--text rounded-lg text-capitalize" @click="reset">Reset</v-btn>
					</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" class="pb-1">
					<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
						<v-tabs class="tabs-vo no-slider" v-model="currentTabs">
							<v-tab @click="getDataAll(1)">Semua</v-tab>
							<v-tab @click="getDataWait(1)">Menunggu</v-tab>
						</v-tabs>
					</v-card>
				</v-col>
			</v-row>
			<div v-if="!loading">
				<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
					<div class="mt-5">
						<v-row v-if="listTransactionApprove.length > 0">
							<v-col cols="12" class="pt-0">
								<v-simple-table class="white-row table-vo table-history-bonus">
									<template v-slot:default>
										<thead class="">
											<tr>
												<th class="text-left" width="15%">Kode</th>
												<th class="text-left" width="25%">Nama Mitra</th>
												<th class="text-left" width="15%">Tanggal</th>
												<th class="text-center" width="5%">Status</th>
												<th class="text-right" width="15%">Total Harga(Rp)</th>
												<th class="text-center" width="5%">Detail</th>
												<th class="text-center" width="10%">Aksi</th>
											</tr>
										</thead>
										<tbody class="grey--text text--darken-3">
											<tr v-for="transaction in listTransactionApprove" :key="transaction.transaction_id">
												<td class="text-left">{{ transaction.transaction_code }}</td>
												<td class="text-left" v-if="transaction.transaction_member_network_code">
													<div>{{ transaction.transaction_member_name }}</div>
													<div class="cl-primary font-weight-500">{{ transaction.transaction_member_network_code }}</div>
												</td>
												<td class="text-left" v-else>{{ transaction.transaction_member_name }} </td>
												<td class="text-left">{{ transaction.transaction_datetime | tanggaljam }}</td>
												<td class="text-center text-uppercase">
													<v-chip
														small
														:color="getTransactionStatus(transaction.transaction_status).color"
														class="font-weight-bold white--text text-uppercase"
													>{{ getTransactionStatus(transaction.transaction_status).label }}</v-chip>
												</td>
												<td class="text-right">{{ transaction.transaction_total_price | toNumber }}</td>
												<td class="text-center">
													<div class="d-flex justify-center">
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<v-btn class="" fab dark x-small depressed color="primary" v-bind="attrs" v-on="on" @click.stop="getDetailAll(transaction.transaction_id)">
																	<v-icon dark>mdi-text-box-search</v-icon>
																</v-btn>
															</template>
															<span>Detail</span>
														</v-tooltip>
													</div>
												</td>
												<td class="text-center">
													<div class="d-flex justify-center" v-if="transaction.transaction_status == 'menunggu'">
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<v-btn class="" fab dark x-small depressed color="green" v-bind="attrs" v-on="on" @click="showConfirm(transaction, 'sukses')">
																	<v-icon dark>mdi-check-circle</v-icon>
																</v-btn>
															</template>
															<span>Approve Transaksi</span>
														</v-tooltip>
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<v-btn class="ml-2" fab dark x-small depressed color="red" v-bind="attrs" v-on="on" @click="showConfirm(transaction, 'ditolak')">
																	<v-icon dark>mdi-close-circle</v-icon>
																</v-btn>
															</template>
															<span>Tolak Transaksi</span>
														</v-tooltip>
													</div>
													<div v-else>-</div>
												</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</v-col>
						</v-row>
						<div class="mt-3" v-if="listTransactionApprove.length == 0">
							<v-row>
								<v-col cols="12" sm="12" md="12">
									<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
										<NoData></NoData>
										<div class="pt-3 text-center cl-secondary">Tidak ada list transaksi yang dapat ditampilkan</div>
									</v-card>
								</v-col>
							</v-row>
						</div>
						
						<div v-if="listTransactionApprove.length > 0">
							<v-row justify="end">
								<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
									<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="transactionApprovePagination.total_page" @input="changePage"></v-pagination>
								</v-col>
								<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
									<div class=" font-size-10">Menampilkan {{ transactionApprovePagination.total_display }} data dari total {{ transactionApprovePagination.total_data }} data</div>
								</v-col>
								<v-col cols="4" sm="2" md="1">
									<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
								</v-col>
							</v-row>
						</div>
					</div>
				</v-scroll-x-reverse-transition>
			</div>
			<div class="mt-4" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalSearch from './components/ModalSearch';
import ModalDetail from './components/ModalDetail';
import ModalConfirm from './components/ModalConfirm';

export default {
	components: {
		ModalSearch, ModalDetail, ModalConfirm
	},
	data() {
		return {
			loading: false,
			currentTabs: 0,
			waitingReport: false,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			params: [],
			msgConfirm: '',
			idApprove: '',
			statusApprove: '',
			isResetSearch: false,
			confirmStatus: 'sukses',
			transactionStatus: [
				{
					status: 'sukses',
					color: 'success',
					label: 'Sukses',
					icon: 'mdi-check-decagram-outline'
				},
				{
					status: 'menunggu',
					color: 'warning',
					label: 'Menunggu',
					icon: 'mdi-timer-sand'
				},
				{
					status: 'ditolak',
					color: 'error',
					label: 'Ditolak',
					icon: 'mdi-close-circle-outline'
				}
			]
		}
	},
	computed: {
		...mapState('transactionProduct', ['listTransactionApprove', 'transactionApprovePagination', 'detailTransactionProduct']),
	},
	methods: {
		...mapActions('transactionProduct', ['getTransactionApproveAll', 'getTransactionApproveWait', 'approveTransactionProduct', 'getDetailTransactionProduct']),

		getTransactionStatus(status) {
			const transaction = this.transactionStatus.find(x => x.status === status)
			if (transaction) return transaction
			else {
				const nontransaction = {
					status: '',
					color: 'secondary',
					label: '',
					icon: ''
				}
				return nontransaction
			}
		},

		queryStringSearch(value) {
			let parameterObject = {}
			let parameter = '{'

			if (value.params) {
				value.params.forEach((value, index) => {
					for (const [key, val] of Object.entries(value)) {
						parameter += `"filter[${index}][${key}]":"${val}",`
					}
				})
			}
			parameter += `"transaction_member_code": "${value.transaction_member_code}", "transaction_member_name": "${value.transaction_member_name}", "limit": "${value.limit}", "page": "${value.page}", "sort": "${value.sort}", "dir": "${value.dir}"`
			parameter += '}'
			parameterObject = JSON.parse(parameter)
			return parameterObject
		},

		async getDataAll(pages) {
			this.loading = await true
			this.waitingReport = await false
			this.$refs.modalSearch.reset()
			if(pages) this.page = await pages
			this.getTransactionApproveAll(this.queryStringSearch({transaction_member_code: '', transaction_member_name: '', sort: 'transaction_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		async getDataWait(pages) {
			this.loading = await true
			this.waitingReport = await true
			this.$refs.modalSearch.reset()
			if(pages) this.page = await pages
			this.getTransactionApproveWait(this.queryStringSearch({transaction_member_code: '', transaction_member_name: '', sort: 'transaction_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		getDetailAll(id) {
			this.getDetailTransactionProduct(id).then(() => {
				this.$refs.modalDetail.modalShow()
			})
		},
		changePage(page) {
			this.page = page
			if (!this.waitingReport) {
				this.getDataAll()
			} else {
				this.getDataWait()
			}
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			if (!this.waitingReport) {
				this.getDataAll()
			} else {
				this.getDataWait()
			}
		},
		showSearch() {
			this.$refs.modalSearch.modalShow()
		},
		reset() {
			this.isResetSearch = true
			this.params = []
			this.page = 1
			if (!this.waitingReport) {
				this.getDataAll()
			} else {
				this.getDataWait()
			}
			this.$refs.modalSearch.reset()
		},
		async cari(data) {
			this.loading = await true
			this.isResetSearch = false
			this.page = await 1
			this.params = await []

			if(data.kode.value)
				await this.params.push(data.kode)
			if(data.date.value)
				await this.params.push(data.date)
			if(data.status.value)
				await this.params.push(data.status)

			if (!this.waitingReport) {
				this.getTransactionApproveAll(this.queryStringSearch({transaction_member_code: data.kode_mitra.value, transaction_member_name: data.nama_mitra.value, sort: 'transaction_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
					this.$refs.modalSearch.modalHide()
					this.loading = false
				})
			} else {
				this.getTransactionApproveWait(this.queryStringSearch({transaction_member_code: data.kode_mitra.value, transaction_member_name: data.nama_mitra.value, sort: 'transaction_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
					this.$refs.modalSearch.modalHide()
					this.loading = false
				})
			}
		},
		showConfirm(data, status) {
			this.confirmStatus = status
			if (status == "sukses") {
				this.msgConfirm = `
					<div class="d-block text-left mb-3">
						<span class="d-block"><span style="display: inline-block; width: 135px;">Kode Transaksi</span>: <strong>${data.transaction_code}</strong></span>
						<span class="d-block"><span style="display: inline-block; width: 135px;">Kode Mitra</span>: <strong>${this.$options.filters.emptyData(data.transaction_member_network_code)}</strong></span>
						<span class="d-block"><span style="display: inline-block; width: 135px;">Nama Mitra</span>: <strong>${data.transaction_member_name}</strong></span>
						<span class="d-block"><span style="display: inline-block; width: 135px;">Total Harga</span>: <strong>${this.$options.filters.toRupiah(data.transaction_total_price)}</strong></span>
					</div>
					Apakah Anda yakin untuk memproses <span class="font-weight-600 cl-primary text-uppercase">approval</span> transaksi ini?
				`
				this.idApprove = data.transaction_id
				this.statusApprove = status
				this.$refs.modalConfirm.modalShow()
			} else {
				this.msgConfirm = `
					<div class="d-block text-left mb-3">
						<span class="d-block"><span style="display: inline-block; width: 135px;">Kode Transaksi</span>: <strong>${data.transaction_code}</strong></span>
						<span class="d-block"><span style="display: inline-block; width: 135px;">Kode Mitra</span>: <strong>${this.$options.filters.emptyData(data.transaction_member_network_code)}</strong></span>
						<span class="d-block"><span style="display: inline-block; width: 135px;">Nama Mitra</span>: <strong>${data.transaction_member_name}</strong></span>
						<span class="d-block"><span style="display: inline-block; width: 135px;">Total Harga</span>: <strong>${this.$options.filters.toRupiah(data.transaction_total_price)}</strong></span>
					</div>
					Apakah Anda yakin untuk <span class="font-weight-600 red--text text-uppercase">menolak</span> transaksi ini?
				`
				this.idApprove = data.transaction_id
				this.statusApprove = status
				this.$refs.modalConfirm.modalShow()
			}
		},
		processApprove() {
			this.$refs.modalConfirm.loadingButton()
			this.approveTransactionProduct({transaction_id: this.idApprove, transaction_status: this.statusApprove}).then(() => {
				this.$refs.modalConfirm.normalButton()
				this.$refs.modalConfirm.modalHide()
				this.currentTabs = 0
				this.getDataAll()
			}).catch(() => {
				this.$refs.modalConfirm.normalButton()
			})
		}
	},
	created(){
		this.$store.dispatch('setPageTitle', `Approval Transaksi`)
		this.getDataAll()
	}
};
</script>